import { useEmpresaAtiva } from "../hooks/useEmpresaAtiva";
import { LogoM5 } from "./LogoM5";
import { LogoRegula } from "./LogoRegula";

/**
 * Logo da empresa ativa. M5 e Regula têm logo fixo (SVG da marca). Demais
 * clientes (ex.: Átomo) usam logo_url (imagem) — modelo "design único VORTEK,
 * só o logo muda por cliente". Sem logo_url, mostra um monograma com a inicial.
 *
 * 05/09 (bloqueio 10): quem decide é `empresas.marca` (dado), com o slug de fallback
 * pra payload que ainda não traz a coluna. Puro/testável em `logoPelaMarca`.
 *
 * 👑 20/10 ZERO M5: sem empresa ativa (carregando, erro, sem vínculo) o logo era o da M5, e o usuário da Regula via a
 * marca da M5 piscar na barra lateral. Agora é um espaço NEUTRO, sem marca nenhuma, até a empresa carregar.
 */
export function logoPelaMarca(e: { slug?: string | null; marca?: string | null; logo_url?: string | null } | null | undefined): "m5" | "regula" | "imagem" | "monograma" | "neutro" {
  if (!e) return "neutro";
  const marca = e.marca ?? (e.slug === "m5group" ? "m5" : e.slug === "regula360" || e.slug === "vitrine-reg" ? "regula" : "vortek");
  if (marca === "m5") return "m5";
  if (marca === "regula") return "regula";
  return e.logo_url ? "imagem" : "monograma";
}

export function LogoEmpresa({ size = 40, onDark = false }: { size?: number; onDark?: boolean }) {
  const { ativa } = useEmpresaAtiva();
  const qual = logoPelaMarca(ativa);
  if (!ativa || qual === "neutro") return <div data-testid="logo-neutro" aria-hidden="true" className="rounded-md shrink-0 bg-muted/40" style={{ width: size, height: size }} />;
  if (qual === "m5") return <LogoM5 size={size} onDark={onDark} />;
  if (qual === "regula") return <LogoRegula size={size} onDark={onDark} />;
  if (ativa.logo_url) {
    return (
      <img
        src={ativa.logo_url}
        alt={ativa.nome}
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain" }}
        className="rounded-md bg-white p-0.5"
      />
    );
  }
  const inicial = (ativa.nome || "?").trim().charAt(0).toUpperCase();
  return (
    <div
      className="rounded-md flex items-center justify-center font-bold shrink-0"
      style={{ width: size, height: size, background: "#C9A55C", color: "#161410", fontSize: size * 0.5 }}
      aria-label={ativa.nome}
    >
      {inicial}
    </div>
  );
}
